import parseDjangoError from './parseDjangoError';

/**
 * Normalise an auth failure body. The backend answers known account states with a
 * stable `code` the pages branch on; anything else is just a message.
 */
export default function toAuthError(data) {
  if (data?.code)
    return { code: data.code, detail: data.detail, email: data.email ?? null };
  return { code: null, detail: parseDjangoError(data), email: null };
}
